import { GameRoomStatus } from '../types/room'
import { StudentRoomState } from '../types/studentRoom'

export const initialStudentRoomState: StudentRoomState = {
  currentRoom: null,
  rooms: [],
  isLoading: false,
  error: null,
  status: GameRoomStatus.NOT_STARTED,
}
